import { render } from "./video-desc.vue?vue&type=template&id=2e0b2314&scoped=true"
import script from "./video-desc.vue?vue&type=script&lang=js"
export * from "./video-desc.vue?vue&type=script&lang=js"

import "./video-desc.vue?vue&type=style&index=0&id=2e0b2314&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0b2314"]])

export default __exports__